module.exports = __webpack_public_path__ + "img/rocket.969043bb.png";